// The two popover triggers deliberately render different elements: Popover is an
// <a>, while PopoverWithContent is a <span role="button"> so it can sit inside
// prose and links without nesting anchors. That difference leaked into the
// paint -- the anchor picked up the link colour and the span inherited the
// surrounding text grey, so the same information glyph appeared in two colours
// depending on which component happened to render it.
//
// Tagging the glyph lets one rule colour it regardless of the element carrying
// it. Only the information circle is tagged: the other glyphs these components
// render (the educational video camera, for instance) are intentionally not
// link-coloured.
const POPOVER_INFO_ICON_CLASS = "app-popover-icon";
const POPOVER_INFO_TRIGGER_CLASS = "app-popover-trigger";

function isPopoverInfoIcon(icon: string): boolean {
  return icon === "info-circle";
}

export function popoverIconClassName(icon: string): string {
  return isPopoverInfoIcon(icon) ? `fa fa-${icon} ${POPOVER_INFO_ICON_CLASS}` : `fa fa-${icon}`;
}

export function popoverTriggerClassName(icon: string, className = ""): string {
  return [className, isPopoverInfoIcon(icon) ? POPOVER_INFO_TRIGGER_CLASS : ""].filter(Boolean).join(" ");
}
